<script setup lang="ts">
import type { FeatureFlagDialogProps } from './feature-flag-dialog';
import ModalV2DefaultFooter from '../ModalV2/ModalV2DefaultFooter.vue';
import ModalV2Layout from '../ModalV2/ModalV2Layout.vue';
import { $t } from '@teachino/shared-i18n';

const props = defineProps<FeatureFlagDialogProps>();
</script>

<template>
  <ModalV2Layout>
    <template #content> We don't have any feature flags yet. </template>
    <template #footer>
      <ModalV2DefaultFooter
        :action-button-label="$t('generic.ok')"
        @on-action="props.resolve({ value: undefined, cancelled: false })"
      />
    </template>
  </ModalV2Layout>
</template>
